import { reduxKey } from './constants';
export function getStoreSlice(state) {
    var _state_reduxKey;
    return (_state_reduxKey = state[reduxKey]) !== null && _state_reduxKey !== void 0 ? _state_reduxKey : {
        connection: {},
        roles: {}
    };
}
export function getIsReduxInitialized(state) {
    return getStoreSlice(state).isReduxInitialized;
}
export function getDiscordGuildConnection(state) {
    return getStoreSlice(state).connection;
}
export function getDiscordGuildRoles(state) {
    return getStoreSlice(state).roles;
}

//# sourceMappingURL=selectors.js.map